import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

import { MainRegion } from './main-region';
import { sideRailTypes } from './master-page';

export interface BodyRegionProps {
  toolbarType: string;
  mainContent: React.ReactElement<{}>;
  sideRailContent: React.ReactElement<{}>;
  toolbarContent: React.ReactElement<{}>;
  navigationContent: React.ReactElement<{}>;
  sideRailType: string;
  flexLayoutSplitView: boolean;
  pageHeader?: string;
}

const mainDefault = (
  <MainRegion>
    <h1>No content has been set for main region</h1>
  </MainRegion>
);

export class BodyRegion extends React.Component<BodyRegionProps> {
  public render() {
    const { mainContent, sideRailContent, toolbarContent, sideRailType, navigationContent, flexLayoutSplitView, pageHeader } = this.props;

    const mainContentRegion = <ErrorBoundary label="hotel.masterPage.main">{mainContent || mainDefault}</ErrorBoundary>;
    const sideRailContentRegion = sideRailContent && <ErrorBoundary label="hotel.masterPage.sideRail">{sideRailContent}</ErrorBoundary>;
    const toolbarContentRegion = toolbarContent && (
      <div className={this.props.toolbarType}>
        <ErrorBoundary label="hotel.masterPage.toolbar">{toolbarContent}</ErrorBoundary>
      </div>
    );
    const navigationContentRegion = navigationContent && (
      <ErrorBoundary label="hotel.masterPage.navigation">{navigationContent}</ErrorBoundary>
    );
    const header = pageHeader && <h1 className="is-visually-hidden">{pageHeader}</h1>;

    if (sideRailType === sideRailTypes.NEXT_TO_MAIN) {
      return (
        <React.Fragment>
          {header}
          {toolbarContentRegion}
          {navigationContentRegion}
          <div className="uitk-flex two-column-body">
            <div className="uitk-flex-grow-1 uitk-cell l-x-padding-six xl-x-padding-six">{mainContentRegion}</div>
            <div className="uitk-flex-shrink-1 side-rail uitk-flex uitk-flex-column">{sideRailContentRegion}</div>
          </div>
        </React.Fragment>
      );
    } else if (sideRailType === sideRailTypes.NEXT_TO_MAIN_AND_TOOLBAR) {
      return (
        <>
          {flexLayoutSplitView && (
            <UitkLayoutFlex alignItems="stretch">
              {header}
              <UitkLayoutFlexItem grow={1} className="xl-r-margin-six">
                <UitkLayoutFlex wrap="wrap">
                  <UitkLayoutFlexItem minWidth="full_width">
                    <div>{mainContentRegion}</div>
                  </UitkLayoutFlexItem>
                </UitkLayoutFlex>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem shrink={1} className="side-rail uitk-flex uitk-flex-column">
                <div>{sideRailContentRegion}</div>
              </UitkLayoutFlexItem>
            </UitkLayoutFlex>
          )}
          {!flexLayoutSplitView && (
            <div className="uitk-flex two-column-body">
              <div className="uitk-flex-grow-1 uitk-cell l-x-padding-six xl-x-padding-six">
                {header}
                {toolbarContentRegion}
                {navigationContentRegion}
                {mainContentRegion}
              </div>
              <AbacusExperiment name="MeSo_move_R1_under_toolbar">
                <AbacusControl>
                  <div className="uitk-flex-shrink-1 side-rail uitk-flex uitk-flex-column">{sideRailContentRegion}</div>
                </AbacusControl>
                <AbacusVariant bucket={1}>
                  <div className="uitk-flex-shrink-1 side-rail uitk-flex uitk-flex-column toolbar-padding">{sideRailContentRegion}</div>
                </AbacusVariant>
              </AbacusExperiment>
            </div>
          )}
        </>
      );
    }

    return (
      <React.Fragment>
        {navigationContentRegion}
        {toolbarContentRegion}
        {mainContentRegion}
      </React.Fragment>
    );
  }
}
